import { styled } from '@mui/material';
import { createContext, useContext, useMemo, useState } from 'react';
import { BottomBar, Box } from 'shell/components';

const AppBarContext = createContext({});
const useAppBar = () => useContext(AppBarContext);

const AppBarProvider = ({ children }) => {
    const [node, setNode] = useState(null);

    const value = useMemo(
        () => ({
            node,
            setNode,
        }),
        [node, setNode]
    );

    return (
        <AppBarContext.Provider value={value}>
            <CustomBox node={node}>{children}</CustomBox>
            {node ? <BottomBar>{node}</BottomBar> : null}
        </AppBarContext.Provider>
    );
};

const CustomBox = styled(Box)(({ node }) => {
    return {
        height: node ? 'calc(100% - 61px)' : '100%',
        overflow: 'auto',
    };
});

export { useAppBar };
export default AppBarProvider;
